import { AnimatePresence, motion } from 'framer-motion';
import React, { useEffect } from 'react';
import Icon, { IconTypes } from "../atoms/icon/Icon";
import { Logo } from "../atoms/Logo";
import styled from "styled-components";
import { smallTablet } from "../atoms/MediaQueries";
import { BodyLarge } from "../atoms/fonts/Body";
import { useTranslation } from "react-i18next";
import Colours from "../atoms/Colours";

export default function Dialog(props: DialogProps) {
  const {t} = useTranslation();
  useEffect(() => {
    if (props.disableScrollLock) {
      return;
    }
    if (props.isOpen) {
      document.body.classList.add('noscroll');
    }
    return () => {
      document.body.classList.remove('noscroll');
    }
  }, [props.isOpen, props.disableScrollLock])

  const close = (e: MouseEvent) => {
    e.stopPropagation();
    if (props.onClose) {
      props.onClose();
    }
  }

  return (
    <AnimatePresence>
      {props.isOpen && (<div className="dialog__container" onClick={(e: any) => e.stopPropagation()}>
        <motion.div className="dialog__animationContainer" onClick={(e: any) => close(e)}
                    initial={{y: 40, opacity: 0}}
                    animate={{
                      y: 0,
                      opacity: 1,
                    }}
                    exit={{opacity: 0, y: 40, transition: {duration: 0.1}}}>
          <div className={`dialog ${props.className || ''}`.trim()} style={props?.style ?? {}} onClick={(e: any) => e.stopPropagation()}>
            {(props.showLogo || props.headerTitle) && (
              <DialogTitleBar>
                {props.headerTitle && <>
                  <BodyLarge weight={600}>{props?.ignoreTranslation ? props.headerTitle : t(props.headerTitle)}</BodyLarge>
                </>}
                {props.showLogo && <DialogLogo><Logo/></DialogLogo>}
              </DialogTitleBar>
            )}
            {props.onClose && <Icon className="dialog__close"
                                    icon={IconTypes.Close}
                                    dataTest={'dialog-close'}
                                    onClick={(e: any) => close(e)}/>}
            <div className="dialog__contentContainer">
              <div className="dialog__content">
                {props.children}
              </div>
            </div>
          </div>
        </motion.div>
      </div>)}
    </AnimatePresence>
  )
}

interface DialogProps {
  children: any;
  isOpen: boolean;
  onClose?: any;
  className?: string;
  showLogo?: boolean;
  style?: any;
  headerTitle?: string;
  headerImage?: string;
  ignoreTranslation?: boolean;
  disableScrollLock?: boolean;
}

const DialogTitleBar = styled.div`
  position: fixed;
  width: 100%;
  background-color: white;
  height: 60px;
  p {
    border-bottom: 1px solid ${Colours.lightGrey};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    position: relative;
    min-height: 60px;
    margin-bottom: 24px;
  }
  @media (${smallTablet}) {
    position: relative;
    margin-top: -60px;
  }
`

const DialogLogo = styled.div`
  position: absolute;
  top: 16px;
  left: 16px;
  @media (${smallTablet}) {
    display: none;
  }
`
